"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconEnhanceStickerActive = Experimental__IconEnhanceStickerActive;
exports.IconEnhanceStickerActive = IconEnhanceStickerActive;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconEnhanceStickerActive/index.tsx)
 */
function IconEnhanceStickerActive(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M7.479.263a.75.75 0 0 1 1.042 0l1.516 1.467 2.089-.296a.75.75 0 0 1 .843.614l.365 2.077 1.863.988c.357.19.5.629.322.992L14.593 8l.926 1.895a.75.75 0 0 1-.322.992l-1.863.988-.365 2.078a.75.75 0 0 1-.843.613l-2.089-.296-1.516 1.467a.75.75 0 0 1-1.042 0L5.963 14.27l-2.089.296a.75.75 0 0 1-.843-.614l-.365-2.077-1.863-.988a.75.75 0 0 1-.322-.992L1.407 8 .481 6.105a.75.75 0 0 1 .322-.992l1.863-.988.365-2.077a.75.75 0 0 1 .843-.614l2.089.296L7.479.263Zm2.31 7.01a.51.51 0 0 0 .332-.174.533.533 0 0 0 0-.696.508.508 0 0 0-.33-.174h-.002a2.535 2.535 0 0 1-1.204-.49c-.405-.309-.75-.782-.824-1.516a.53.53 0 0 0-.162-.333.505.505 0 0 0-.696 0 .53.53 0 0 0-.161.333c-.074.734-.42 1.207-.825 1.516-.42.32-.905.46-1.203.489a.508.508 0 0 0-.334.173.533.533 0 0 0 0 .7c.085.097.204.16.334.172.298.03.783.17 1.203.49.406.308.751.781.825 1.516a.53.53 0 0 0 .162.332.505.505 0 0 0 .694 0 .53.53 0 0 0 .163-.332c.073-.734.419-1.208.824-1.516.42-.32.907-.46 1.204-.49Zm-.633 2.776a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M11.305 1.281a1 1 0 0 1 1.39 0l2.121 2.052 2.922-.413a1 1 0 0 1 1.125.817l.51 2.906 2.606 1.383a1 1 0 0 1 .43 1.323L21.113 12l1.296 2.651a1 1 0 0 1-.43 1.322l-2.606 1.383-.51 2.907a1 1 0 0 1-1.125.817l-2.922-.413-2.12 2.052a1 1 0 0 1-1.391 0l-2.121-2.052-2.922.413a1 1 0 0 1-1.125-.817l-.51-2.907-2.606-1.383a1 1 0 0 1-.43-1.322L2.887 12 1.59 9.349a1 1 0 0 1 .43-1.323l2.606-1.383.51-2.906a1 1 0 0 1 1.125-.817l2.922.413 2.12-2.052Zm2.446 10.566h.001a.828.828 0 0 0 .54-.285.86.86 0 0 0 0-1.122.828.828 0 0 0-.54-.284h-.002a3.047 3.047 0 0 1-1.44-.588c-.48-.366-.89-.924-.979-1.802a.856.856 0 0 0-.261-.538.825.825 0 0 0-1.136 0 .856.856 0 0 0-.262.538c-.088.878-.498 1.436-.978 1.802a3.037 3.037 0 0 1-1.439.587.828.828 0 0 0-.545.281.86.86 0 0 0 0 1.13.828.828 0 0 0 .545.281c.35.035.934.203 1.439.586.48.366.89.925.979 1.804.02.202.111.394.262.537a.825.825 0 0 0 1.133 0 .857.857 0 0 0 .263-.537c.088-.879.498-1.437.979-1.803a3.042 3.042 0 0 1 1.44-.587ZM13.5 15a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconEnhanceStickerActive is deprecated and will be archived soon. Use IconEnhanceStickerActive instead.
 */
function Experimental__IconEnhanceStickerActive(props) {
  return /*#__PURE__*/_react["default"].createElement(IconEnhanceStickerActive, props);
}